﻿import { GuiListGeneric } from "../GuiListGeneric";
export class GuiListEanvAktionenChoose extends GuiListGeneric {

    constructor() {
        super("GuiListEanvAktionenChoose");
    }

    protected override attachListEvents() {
        super.attachListEvents();
       
    }

    override clickRow( ): void {
        // keine Funktion in diesem Modul
    }
   

}